import { estadosEvento, hotelesOpciones } from "../../hook/Arreglos";
import { format } from "date-fns";
import { cancelar_EventosReasignacion, eliminar_EventosReasignacion, EXTARERTODOSOSVENTOSTOKEN, InsertarNuevoEvento, obtenerLosDatosEventos, validarEventosCalendario } from "./Api_Evento_Providers";
import Swal from "sweetalert2";
import { setLimpiarTemporales } from "./eventoSlice";
import { insertartBitacoraCliente } from "../clientes/thunkClientes";
import { insertartBitacoraEmpresa } from "../Empresa/thunkEmpresa";

async function generateTokenAsync() {

    function generarLetrasAleatorias() {
        const letras = "123ABCDEFGHIJKLMNOPQRSTUVWXY456789Zabcdefghijklmnopqrstuvwxyz";
        return Array.from({ length: 5 }, () => letras[Math.floor(Math.random() * letras.length)]).join("");
    }
    // Crear encabezado
    const header = btoa('{"alg":"HS256","typ":"JWT"}');

    // Crear payload con fecha y valores aleatorios
    const now = new Date();
    const payload = {
        date: now.toISOString(), // Fecha completa en formato ISO
        randomString: Math.random().toString(36).substring(2, 10), // Letras y números aleatorios
        timestamp: now.getTime(), // Tiempo en milisegundos
    };
    const base64Payload = btoa(JSON.stringify(payload));

    // Crear una "firma" simple usando valores aleatorios
    const signature = btoa(`${now.getTime()}${Math.random().toString(36).substring(2, 15)}`).substring(0, 25); // Limitar a 32 caracteres

    // Combinar en formato de token
    const token = `${header}.${base64Payload}.${signature}-${generarLetrasAleatorias()}`;
    return token;
}






/**
 * Función para crear un evento basado en los datos proporcionados por el formulario.
 * Proporciona logs detallados para depuración y realiza el procesamiento necesario.
 *
 * @param {Object} formulario - Datos del formulario del evento.
 * @param {Array} eventos - Lista de eventos existentes.
 * @returns {Function} - Función asíncrona para manejar la creación del evento.
 */
export const crearEvento = (formulario, eventos) => {

    console.clear(); // Limpia la consola para mantener los logs relevantes y evitar ruido innecesario.

    /**
     * Función: Obtiene un string de valores formateados desde una propiedad específica de los ejecutivos seleccionados.
     *
     * @param {string} propiedad - Nombre de la propiedad a extraer y formatear.
     * @param {boolean} usarComillas - Indica si los valores deben envolverse en comillas.
     * @returns {string} - Cadena con los valores formateados, separados por comas.
     */
    const obtenerValoresFormateados = (propiedad, usarComillas = true) => {
        return (
            formulario.selectedExecutives?.map((ejecutivo) => (usarComillas ? `"${ejecutivo[propiedad]}"` : ejecutivo[propiedad])).join(",") || "Ninguno" // Valor predeterminado si no hay ejecutivos seleccionados.
        );
    };

    // **Obtener valores formateados de los ejecutivos seleccionados**
    // Valores (ID u otros atributos) con comillas
    const valoresEjecutivos = obtenerValoresFormateados("value", true);
    // Etiquetas (nombres u otras descripciones) sin comillas
    const etiquetasEjecutivos = obtenerValoresFormateados("label", false);

    /**
     * Identificar el estado seleccionado del evento y obtener información relevante.
     */
    // Encuentra el estado en base al ID seleccionado en el formulario.
    const estadoSeleccionado = estadosEvento.find((estado) => estado.id_estado === parseInt(formulario.estadoEvento, 10));
    // Color del estado seleccionado; usa un valor predeterminado si no se encuentra.
    const colorEstado = estadoSeleccionado?.color_estado || "Color no encontrado";
    // ID del estado seleccionado; usa 0 si no se encuentra.
    const idEstado = estadoSeleccionado?.id_estado || 0;

    /**
     * Obtener valores adicionales del formulario con valores por defecto si están vacíos.
     */
    // Cantidad de personas especificada en el formulario o valor predeterminado.
    const cantidadPersonas = formulario.cantidadPersonas || 0;
    // Tipo de montaje del evento especificado en el formulario o un mensaje predeterminado.
    const montajeEvento = formulario.montajeEvento || "No especificado";
    // Notas asociadas al evento o un mensaje predeterminado.
    const notasEvento = formulario.notasEvento || "Sin notas";

    // Nombre del evento 
    const nombreEvento = formulario.nombreEvento || "Sin nombre";

    // ingreso monto
    const monto = formulario.ingresoMonto || 0;

    // tipo de evento seleccionado
    const tipoEvento = formulario.tipodeeventos || "Sin tipo";
    /**
     * Serializar datos adicionales relacionados con el evento.
     */
    // Lista de eventos si está presente, de lo contrario un arreglo vacío.
    const eventosLista = eventos || [];
    // ID de la empresa seleccionada; usa 0 si no se encuentra.
    const empresaSeleccionada = formulario.empresaSeleccionada?.value || 0;
    // ID del cliente seleccionado; usa 0 si no se encuentra.
    const clienteSeleccionado = formulario.clienteSeleccionado?.value || 0;



    // *** Resumen del flujo ***
    // - Se limpió la consola para tener registros limpios.
    // - Se obtuvieron valores formateados de los ejecutivos seleccionados (con y sin comillas).
    // - Se identificó el estado seleccionado del evento y sus propiedades relevantes (color e ID).
    // - Se extrajeron valores adicionales del formulario con valores predeterminados cuando fuera necesario.
    // - Se prepararon las listas de eventos y datos seleccionados para su posterior uso.

    // Retornar una función asíncrona para manejar el procesamiento del evento
    return async (dispatch) => {
        try {
            // Utilidad: Formatea una fecha en un formato legible para el usuario (es-ES).
            const formatearFecha = (fecha) =>
                fecha
                    ? new Date(fecha).toLocaleString("es-ES", {
                          hour: "numeric",
                          minute: "2-digit",
                          hour12: true,
                          year: "numeric",
                          month: "long",
                          day: "numeric",
                          weekday: "long",
                      })
                    : "N/D";

            // Utilidad: Obtiene el nombre del hotel a partir de su ID.
            // Si no encuentra el hotel, devuelve "No encontrado".
            const obtenerNombreHotel = (idHotel) => hotelesOpciones.find((opcion) => opcion.value === idHotel?.toString())?.label || "No encontrado";

            // Función: Valida conflictos en una lista de eventos
            const validacionEvnto = async (eventosLista, token, recolectarDaros) => {
                const conflictosMensajes = []; // Acumula los mensajes de conflictos detectados.

                // Mostrar un preloader mientras se ejecuta la validación
                Swal.fire({
                    title: "Validando eventos...",
                    text: "Por favor espera mientras se valida la información.",
                    allowOutsideClick: false,
                    didOpen: () => {
                        Swal.showLoading(); // Muestra un spinner para indicar progreso
                    },
                });

                // Iterar sobre cada evento de la lista para validar
                for (const eventoRecorrer of eventosLista) {
                    // Ajustar rangos de fecha para incluir todo el día.
                    const fi = eventoRecorrer.start.split(" ")[0] + " 00:00:00";
                    const fn = eventoRecorrer.end.split(" ")[0] + " 23:59:59";
                    const hotelid = eventoRecorrer.hotelid;
                    const salonid = eventoRecorrer.salonid;

                    // Llamada a la API para validar eventos dentro del rango de fechas y lugar especificado.
                    const respuestaValidation = await validarEventosCalendario({ hotelid, salonid, fi, fn });

                    // Convertir las fechas de inicio y fin del evento actual a objetos Date.
                    const fi2 = new Date(eventoRecorrer.start);
                    const fn2 = new Date(eventoRecorrer.end);

                    // Filtrar eventos en conflicto en base a las fechas
                    const eventosConflicto = respuestaValidation.data.data.filter((evento) => {
                        const inicioEvento = new Date(evento.fech_Inicio_evento);
                        const finEvento = new Date(evento.fech_final_evento);

                        // Verificar si hay algún traslape entre los eventos
                        return (
                            (fi2 > inicioEvento && fi2 < finEvento) || // El inicio del evento está dentro de otro evento
                            (fn2 > inicioEvento && fn2 < finEvento) || // El fin del evento está dentro de otro evento
                            (inicioEvento >= fi2 && finEvento <= fn2) // El evento completo está contenido dentro de otro evento
                        );
                    });

                    // Si hay eventos en conflicto, preparar los mensajes detallados
                    if (eventosConflicto.length > 0) {
                        const conflictos = eventosConflicto
                            .map((evento) => {
                                // Formato detallado de cada conflicto detectado
                                return `
                                <div style="padding: 10px; border-bottom: 1px solid #ddd; margin-bottom: 10px;">
                                    <p style="margin: 0;"><b>Evento Encontrado:</b> ${evento.nombre_evento}</p>
                                    <p style="margin: 0;"><b>Salón:</b> ${eventoRecorrer.nombreSalon}</p>
                                    <p style="margin: 0;"><b>Hotel:</b> ${obtenerNombreHotel(eventoRecorrer.hotelid)}</p>
                                    <p style="margin: 0;"><b>Desde:</b> ${formatearFecha(evento.fech_Inicio_evento)}</p>
                                    <p style="margin: 0;"><b>Hasta:</b> ${formatearFecha(evento.fech_final_evento)}</p>
                                </div>`;
                            })
                            .join(""); // Unir todos los conflictos como bloques HTML

                        // Agregar mensaje principal con los detalles del conflicto
                        conflictosMensajes.push(`
                        <div style="text-align: left; margin-bottom: 15px;">
                            <h3 style="margin-bottom: 10px; font-size: 18px; color: #e74c3c;">Conflicto en el salón: ${eventoRecorrer.nombreSalon}</h3>
                            <p style="margin: 0;"><b>Desde :</b> ${formatearFecha(eventoRecorrer.start)}</p>
                            <p style="margin: 0; margin-bottom: 10px;"><b>Hasta:</b> ${formatearFecha(eventoRecorrer.end)}</p>
                            ${conflictos}
                        </div>
                    `);
                    }
                }

                Swal.close(); // Ocultar el preloader una vez finalizada la validación.

                if (conflictosMensajes.length > 0) {
                    // Mostrar los conflictos detectados en un modal estilizado
                    Swal.fire({
                        title: "Conflictos encontrados",
                        icon: "error",
                        html: `
                        <div style="text-align: left; font-family: Arial, sans-serif; line-height: 1.5; font-size: 14px;">
                            <p style="font-weight: bold; margin-bottom: 15px; color: #333;">Los siguientes conflictos han sido detectados:</p>
                            <ul style="padding-left: 20px; list-style-type: disc;">
                                ${conflictosMensajes.map((mensaje) => `<li style="margin-bottom: 20px; padding: 10px; background: #f9f9f9; border: 1px solid #ddd; border-radius: 5px;">${mensaje}</li>`).join("")}
                            </ul>
                        </div>`,
                        width: "600px",
                        confirmButtonText: "Entendido",
                        customClass: {
                            popup: "swal-wide", // Clase CSS personalizada
                        },
                    });
                    return "error"; // Retornar un valor de error para indicar que no se pueden insertar los eventos.
                } else {
                    // // Aquí puedes realizar la lógica para insertar los eventos
                    eventosLista.forEach(async (evento) => {
                        await dispatch(insertarEvento(evento, token, recolectarDaros));
                    });

                    if (recolectarDaros.idCliente > 0) {
                         await dispatch(
                             insertartBitacoraCliente({
                                 bitacora_cliente: recolectarDaros.idCliente,
                                 bitacora_nombreCliente: "Evento Asignado",
                                 bitacora_detalle: `Se le ha generado un evento a este cliente con el nombre de: ${nombreEvento}`,
                             }),
                         );
                    }
                     if (recolectarDaros.idEmpresa > 0) {
                         const nota = `Se le ha creado  un evento a esta empresa con el nombre de: ${nombreEvento}`;
                         const idEmpresa = recolectarDaros.idEmpresa;
                         await dispatch(insertartBitacoraEmpresa(nota, idEmpresa));
                     }
                    dispatch(setLimpiarTemporales());
                    return "ok"; // Retornar un valor de error para indicar que no se pueden insertar los eventos.
                }
            };

            const token = await generateTokenAsync(); // Espera a que el token se genere

            const recolectarDaros = {
                ejecutivos: valoresEjecutivos,
                nombresEjecutivos: etiquetasEjecutivos,
                colorEvento: colorEstado,
                idEstadoEvento: idEstado,
                CantPersonas: cantidadPersonas,
                Montaje: montajeEvento,
                Notas: notasEvento,
                idEmpresa: empresaSeleccionada,
                idCliente: clienteSeleccionado,
                nombreEvento: nombreEvento,
                ingresoMonto: monto,
                tipoEvento: tipoEvento,
            };

            // Ejecutar validación de eventos
           const result = await validacionEvnto(eventosLista, token , recolectarDaros);

           return result;


        } catch (error) {
            // Manejo de errores con registro en consola
            console.error("🚀 Error al procesar el evento:", error);
        }
    };
};



/**
 * Thunk para manejar la inserción de un nuevo evento en el calendario.
 * 
 * @param {Object} evento - Datos del evento a registrar (debe cumplir con el esquema esperado por la API).
 * @param {string} token - Token de autenticación del usuario que realiza la acción.
 * @param {boolean} recolectarDaros - Bandera para determinar si se deben recolectar más datos tras la inserción.
 * @returns {Function} Una función asíncrona que maneja la inserción del evento utilizando el thunk.
 * 
 * @example
 * dispatch(insertarEvento(evento, token, true));
 */
export const insertarEvento = (evento, token, recolectarDaros) => {

    // Retorna una función asíncrona que puede ser despachada dentro de Redux o ejecutada directamente.
   return async (dispatch, getState) => {
       const { id_admin } = getState().auth;
       try {
           // Llama a la función `InsertarNuevoEvento` para registrar el evento en la API.
           await InsertarNuevoEvento({ evento, token, recolectarDaros, id_admin });

           // Opcional: Retornar datos relevantes del resultado si es necesario para el flujo del programa.
           // return resultado.data["0"];
       } catch (error) {
           // Manejo de errores en caso de fallo en la solicitud.
           console.error("Error al insertar el evento en el calendario:", error);

           // Opcional: Lanzar el error o manejarlo según las necesidades del proyecto.
           throw new Error("No se pudo insertar el evento. Por favor, intente nuevamente.");
       }
   };
};



export const DatosEventos = (eventoId) => {
    // Retorna una función asíncrona que puede ser despachada dentro de Redux o ejecutada directamente.
    return async () => {

        try {
            // Llama a la función `InsertarNuevoEvento` para registrar el evento en la API.
            const resultado = await obtenerLosDatosEventos({ id: eventoId });

            // Opcional: Retornar datos relevantes del resultado si es necesario para el flujo del programa.
            return resultado.data;
        } catch (error) {
            // Manejo de errores en caso de fallo en la solicitud.
            console.error("Error al insertar el evento en el calendario:", error);

            // Opcional: Lanzar el error o manejarlo según las necesidades del proyecto.
            throw new Error("No se pudo insertar el evento. Por favor, intente nuevamente.");
        }
    };
};




export const editarEvento = (formulario, eventos) => {

    // Retorna una función asíncrona que puede ser despachada dentro de Redux o ejecutada directamente.
    return async (dispatch) => {
        try {
            const eventosLista = [...formulario.listaEventosAsignados, ...eventos];

            const result=  await dispatch(funcionEditar(formulario, eventosLista));
            // // Llama a la función `InsertarNuevoEvento` para registrar el evento en la API.
            // const resultado = await obtenerLosDatosEventos({ id: eventoId });

            // // Opcional: Retornar datos relevantes del resultado si es necesario para el flujo del programa.
            return result;
        } catch (error) {
            // Manejo de errores en caso de fallo en la solicitud.
            console.error("Error al insertar el evento en el calendario:", error);

            // Opcional: Lanzar el error o manejarlo según las necesidades del proyecto.
            throw new Error("No se pudo insertar el evento. Por favor, intente nuevamente.");
        }
    };
};


export const funcionEditar = (formulario, eventos) => {

    console.clear(); // Limpia la consola para mantener los logs relevantes y evitar ruido innecesario.

    /**
     * Función: Obtiene un string de valores formateados desde una propiedad específica de los ejecutivos seleccionados.
     *
     * @param {string} propiedad - Nombre de la propiedad a extraer y formatear.
     * @param {boolean} usarComillas - Indica si los valores deben envolverse en comillas.
     * @returns {string} - Cadena con los valores formateados, separados por comas.
     */
    const obtenerValoresFormateados = (propiedad, usarComillas = true) => {
        return (
            formulario.selectedExecutives?.map((ejecutivo) => (usarComillas ? `"${ejecutivo[propiedad]}"` : ejecutivo[propiedad])).join(",") || "Ninguno" // Valor predeterminado si no hay ejecutivos seleccionados.
        );
    };

    // **Obtener valores formateados de los ejecutivos seleccionados**
    // Valores (ID u otros atributos) con comillas
    const valoresEjecutivos = obtenerValoresFormateados("value", true);
    // Etiquetas (nombres u otras descripciones) sin comillas
    const etiquetasEjecutivos = obtenerValoresFormateados("label", false);

    /**
     * Identificar el estado seleccionado del evento y obtener información relevante.
     */
    // Encuentra el estado en base al ID seleccionado en el formulario.
    const estadoSeleccionado = estadosEvento.find((estado) => estado.id_estado === parseInt(formulario.estadoEvento, 10));
    // Color del estado seleccionado; usa un valor predeterminado si no se encuentra.
    const colorEstado = estadoSeleccionado?.color_estado || "Color no encontrado";
    // ID del estado seleccionado; usa 0 si no se encuentra.
    const idEstado = estadoSeleccionado?.id_estado || 0;

    /**
     * Obtener valores adicionales del formulario con valores por defecto si están vacíos.
     */
    // Cantidad de personas especificada en el formulario o valor predeterminado.
    const cantidadPersonas = formulario.cantidadPersonas || 0;
    // Tipo de montaje del evento especificado en el formulario o un mensaje predeterminado.
    const montajeEvento = formulario.montajeEvento || "No especificado";
    // Notas asociadas al evento o un mensaje predeterminado.
    const notasEvento = formulario.notasEvento || "Sin notas";

    // Nombre del evento
    const nombreEvento = formulario.nombreEvento || "Sin nombre";

    // ingreso monto
    const monto = formulario.ingresoMonto || 0;

    // tipo de evento seleccionado
    const tipoEvento = formulario.tipodeeventos || "Sin tipo";
    /**
     * Serializar datos adicionales relacionados con el evento.
     */
    // Lista de eventos si está presente, de lo contrario un arreglo vacío.
    const eventosLista = eventos || [];
    // ID de la empresa seleccionada; usa 0 si no se encuentra.
    const empresaSeleccionada = formulario.empresaSeleccionada?.value || 0;
    // ID del cliente seleccionado; usa 0 si no se encuentra.
    const clienteSeleccionado = formulario.clienteSeleccionado?.value || 0;

    // *** Resumen del flujo ***
    // - Se limpió la consola para tener registros limpios.
    // - Se obtuvieron valores formateados de los ejecutivos seleccionados (con y sin comillas).
    // - Se identificó el estado seleccionado del evento y sus propiedades relevantes (color e ID).
    // - Se extrajeron valores adicionales del formulario con valores predeterminados cuando fuera necesario.
    // - Se prepararon las listas de eventos y datos seleccionados para su posterior uso.

    // Retornar una función asíncrona para manejar el procesamiento del evento
    return async (dispatch) => {
        try {
            // Utilidad: Formatea una fecha en un formato legible para el usuario (es-ES).
            const formatearFecha = (fecha) =>
                fecha
                    ? new Date(fecha).toLocaleString("es-ES", {
                          hour: "numeric",
                          minute: "2-digit",
                          hour12: true,
                          year: "numeric",
                          month: "long",
                          day: "numeric",
                          weekday: "long",
                      })
                    : "N/D";

            // Utilidad: Obtiene el nombre del hotel a partir de su ID.
            // Si no encuentra el hotel, devuelve "No encontrado".
            const obtenerNombreHotel = (idHotel) => hotelesOpciones.find((opcion) => opcion.value === idHotel?.toString())?.label || "No encontrado";

            // Función: Valida conflictos en una lista de eventos
            const validacionEvnto = async (eventosLista, token, recolectarDaros) => {
                const conflictosMensajes = []; // Acumula los mensajes de conflictos detectados.

                // Mostrar un preloader mientras se ejecuta la validación
                Swal.fire({
                    title: "Validando eventos...",
                    text: "Por favor espera mientras se valida la información.",
                    allowOutsideClick: false,
                    didOpen: () => {
                        Swal.showLoading(); // Muestra un spinner para indicar progreso
                    },
                });

                // Iterar sobre cada evento de la lista para validar
                for (const eventoRecorrer of eventosLista) {
                    // Ajustar rangos de fecha para incluir todo el día.
                    const fi = eventoRecorrer.start.split(" ")[0] + " 00:00:00";
                    const fn = eventoRecorrer.end.split(" ")[0] + " 23:59:59";
                    const hotelid = eventoRecorrer.hotelid;
                    const salonid = eventoRecorrer.salonid;

                    // Llamada a la API para validar eventos dentro del rango de fechas y lugar especificado.
                    const respuestaValidation = await validarEventosCalendario({ hotelid, salonid, fi, fn });

                    // Convertir las fechas de inicio y fin del evento actual a objetos Date.
                    const fi2 = new Date(eventoRecorrer.start);
                    const fn2 = new Date(eventoRecorrer.end);

                    // Filtrar eventos en conflicto en base a las fechas
                    const eventosConflicto = respuestaValidation.data.data.filter((evento) => {
                        const inicioEvento = new Date(evento.fech_Inicio_evento);
                        const finEvento = new Date(evento.fech_final_evento);

                        // Verificar si hay algún traslape entre los eventos
                        return (
                            (fi2 > inicioEvento && fi2 < finEvento) || // El inicio del evento está dentro de otro evento
                            (fn2 > inicioEvento && fn2 < finEvento) || // El fin del evento está dentro de otro evento
                            (inicioEvento >= fi2 && finEvento <= fn2) // El evento completo está contenido dentro de otro evento
                        );
                    });

                    // Si hay eventos en conflicto, preparar los mensajes detallados
                    if (eventosConflicto.length > 0) {
                        const conflictos = eventosConflicto
                            .map((evento) => {
                                // Formato detallado de cada conflicto detectado
                                return `
                                <div style="padding: 10px; border-bottom: 1px solid #ddd; margin-bottom: 10px;">
                                    <p style="margin: 0;"><b>Evento Encontrado:</b> ${evento.nombre_evento}</p>
                                    <p style="margin: 0;"><b>Salón:</b> ${eventoRecorrer.nombreSalon}</p>
                                    <p style="margin: 0;"><b>Hotel:</b> ${obtenerNombreHotel(eventoRecorrer.hotelid)}</p>
                                    <p style="margin: 0;"><b>Desde:</b> ${formatearFecha(evento.fech_Inicio_evento)}</p>
                                    <p style="margin: 0;"><b>Hasta:</b> ${formatearFecha(evento.fech_final_evento)}</p>
                                </div>`;
                            })
                            .join(""); // Unir todos los conflictos como bloques HTML

                        // Agregar mensaje principal con los detalles del conflicto
                        conflictosMensajes.push(`
                        <div style="text-align: left; margin-bottom: 15px;">
                            <h3 style="margin-bottom: 10px; font-size: 18px; color: #e74c3c;">Conflicto en el salón: ${eventoRecorrer.nombreSalon}</h3>
                            <p style="margin: 0;"><b>Desde :</b> ${formatearFecha(eventoRecorrer.start)}</p>
                            <p style="margin: 0; margin-bottom: 10px;"><b>Hasta:</b> ${formatearFecha(eventoRecorrer.end)}</p>
                            ${conflictos}
                        </div>
                    `);
                    }
                }

                Swal.close(); // Ocultar el preloader una vez finalizada la validación.

                if (conflictosMensajes.length > 0) {
                    // Mostrar los conflictos detectados en un modal estilizado
                    Swal.fire({
                        title: "Conflictos encontrados",
                        icon: "error",
                        html: `
                        <div style="text-align: left; font-family: Arial, sans-serif; line-height: 1.5; font-size: 14px;">
                            <p style="font-weight: bold; margin-bottom: 15px; color: #333;">Los siguientes conflictos han sido detectados:</p>
                            <ul style="padding-left: 20px; list-style-type: disc;">
                                ${conflictosMensajes.map((mensaje) => `<li style="margin-bottom: 20px; padding: 10px; background: #f9f9f9; border: 1px solid #ddd; border-radius: 5px;">${mensaje}</li>`).join("")}
                            </ul>
                        </div>`,
                        width: "600px",
                        confirmButtonText: "Entendido",
                        customClass: {
                            popup: "swal-wide", // Clase CSS personalizada
                        },
                    });
                    return "error"; // Retornar un valor de error para indicar que no se pueden insertar los eventos.
                } else {
                    // // Aquí puedes realizar la lógica para insertar los eventos
                    eventosLista.forEach(async (evento) => {
                        await dispatch(insertarEvento(evento, token, recolectarDaros));
                    });
                    if (recolectarDaros.idCliente > 0) {
                        await dispatch(
                            insertartBitacoraCliente({
                                bitacora_cliente: recolectarDaros.idCliente,
                                bitacora_nombreCliente: "Evento Editado",
                                bitacora_detalle: `Se le ha generado un evento a este cliente con el nombre de: ${nombreEvento}`,
                            }),
                        );
                    }
                    if (recolectarDaros.idEmpresa > 0) {
                        const nota = `Se le ha editado un evento a esta empresa con el nombre de: ${nombreEvento}`;
                        const idEmpresa = recolectarDaros.idEmpresa;
                        await dispatch(insertartBitacoraEmpresa(nota, idEmpresa));
                    }
                    dispatch(setLimpiarTemporales());
                    return "ok"; // Retornar un valor de error para indicar que no se pueden insertar los eventos.
                }
            };

            const token = formulario.token; // Espera a que el token se genere

            const recolectarDaros = {
                ejecutivos: valoresEjecutivos,
                nombresEjecutivos: etiquetasEjecutivos,
                colorEvento: colorEstado,
                idEstadoEvento: idEstado,
                CantPersonas: cantidadPersonas,
                Montaje: montajeEvento,
                Notas: notasEvento,
                idEmpresa: empresaSeleccionada,
                idCliente: clienteSeleccionado,
                nombreEvento: nombreEvento,
                ingresoMonto: monto,
                tipoEvento: tipoEvento,
                token: formulario.token,
            };
            await dispatch(eliminarEventosReasignacion(token));

            // Ejecutar validación de eventos
            const result = await validacionEvnto(eventosLista, token, recolectarDaros);

            return result; // Retorno simulado
        } catch (error) {
            // Manejo de errores con registro en consola
            console.error("🚀 Error al procesar el evento:", error);
        }
    };
};


export const eliminarEventosReasignacion = (token) => {
    // Retorna una función asíncrona que puede ser utilizada como un thunk de Redux
    // o ejecutada directamente en el contexto del programa.
    return async () => {
        try {
            // Realiza la eliminación de eventos de reasignación utilizando el token proporcionado.
            await eliminar_EventosReasignacion({ token });
            // Opcional: Retornar datos relevantes del resultado si se necesitan en el flujo del programa.
            // return resultado.data;
        } catch (error) {
            // Manejo de errores en caso de que la solicitud falle.
            console.error("Error al eliminar los eventos de reasignación:", error);

            // Opcional: Lanzar el error o manejarlo según los requisitos del proyecto.
            throw new Error("No se pudieron eliminar los eventos de reasignación. Por favor, intente nuevamente.");
        }
    };
    
};





export const cancelarEventosReasignacion = (token) => {
    // Devuelve una función asíncrona que puede utilizarse como un thunk de Redux
    // o ejecutarse directamente en el contexto del programa.
    return async () => {
        try {
            // Llama a la función para cancelar los eventos de reasignación, usando el token proporcionado.
            await cancelar_EventosReasignacion({ token });

            // Opcional: Retornar datos relevantes del resultado si es necesario para el flujo del programa.
            // return resultado.data;
        } catch (error) {
            // Maneja errores en caso de fallo durante la solicitud.
            console.error("Error al cancelar los eventos de reasignación:", error);

            // Opcional: Lanza el error para manejarlo en una capa superior o según los requisitos del proyecto.
            throw new Error("No se pudieron cancelar los eventos de reasignación. Por favor, intente nuevamente.");
        }
    };
};

export const extarerEventoToken = (token) => {
    // Retorna una función asíncrona que puede ser utilizada como un thunk de Redux
    // o ejecutada directamente en el contexto del programa.
    return async () => {
        try {
            // Llama a la función para obtener todos los eventos asociados al token proporcionado.
            const result = await EXTARERTODOSOSVENTOSTOKEN({ token });

            // Retorna los datos del resultado, generalmente para usarlos en el flujo del programa.
            return result.data;
        } catch (error) {
            // Maneja errores en caso de que la solicitud falle.
            console.error("Error al obtener los eventos asociados al token:", error);

            // Lanza un error con un mensaje específico para que pueda ser manejado en niveles superiores.
            throw new Error("No se pudieron obtener los eventos asociados. Por favor, intente nuevamente.");
        }
    };
};

